<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Asessment</h3>
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
                label="Class"
                :items="myclasses"
                item-text="name"
                item-value="id"
                v-model="selected_class"
              />
            </v-flex>
            <v-flex xs6>
              <v-autocomplete
                label="Subject"
                :items="c_subjects"
                item-text="name"
                item-value="id"
                v-model="selected_subject"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card class="elevation-6">
                <v-card-title>
                  <h4 style="margin:10px">list</h4>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-form ref="form">
                  <v-data-table
                    :key="refresh_key"
                    :headers="assessment_headers"
                    :items="c_marks"
                    class="elevation-0"
                    :search="search"
                    :disable-pagination="true"
                    :loading="mloading"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-center">{{ props.index + 1 }}</td>
                      <td class="text-xs-center">{{ props.item.s_bio.name}}</td>
                      <td class="text-xs-center">{{ props.item.rollno }}</td>
                      <td class="text-xs-center">
                        <v-text-field :value="props.item.s_mark.class_score" @input="set_cs($event,props.index)" :rules="validRules.c_score" type="number" step="any"></v-text-field>
                      </td>
                      <td class="text-xs-center">
                        <v-text-field :value="props.item.s_mark.exam_score" @input="set_es($event,props.index)" :rules="validRules.e_score" type="number" step="any"></v-text-field>
                      </td>
                    </template>
                  </v-data-table>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="success" @click="savemarks()">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "assessment-view",
  layout: "teacher",
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      modal: false,
      selected_class: {},
      selected_subject: "",
      search: "",
      refresh_key: 0,
      c_marks: [],
      c_subjects: [],
      assessment_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Student",
          sortable: false,
          value: "name"
        },
        {
          text: "Student ID",
          sortable: false,
          value: "roll_no"
        },
        {
          text: "Class Score (30%)",
          sortable: false,
          value: "class_score"
        },
        {
          text: "Exam Score (70%)",
          sortable: false,
          value: "class_score"
        }
      ]
    };
  },
  methods: {
    showScores() {
      console.log(this.c_marks);
    },
    savemarks() {
       if (!this.$refs.form.validate()) {
        return;
      }
      this.$store.dispatch("marks/add", {
        subject_id: this.selected_subject,
        c_marks: this.c_marks
      });

      if (this.merrors ==null) {
        //this.class_model = this.class_modelcp;
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Marks saved successfully.",
          title: "Assessment",
          modal: false
        });
      }
    },
    set_cs(event,idx){
     // console.log("poolklklkh",event)
      this.$store.dispatch('marks/set_cs',{idx:idx,score:event})
    },
    set_es(event,idx){
      this.$store.dispatch('marks/set_es',{idx:idx,score:event})
    }
  },
  mounted() {
    this.$store.dispatch("classes/getMyClasses");
  },
  computed: {
    ...mapGetters({
      myclasses: "classes/MYCLASSES",
      errors: "classes/CLASS_ERROR",
      loading: "classes/CLASS_LOADING",

      marks: "marks/MARKS",
      merrors: "marks/MARK_ERROR",
      mloading: "marks/MARK_LOADING"
    })
  },
  watch: {
    selected_class(val) {
      this.c_marks = [];
      this.selected_subject = "";
      var data = this.myclasses.find(x => x.id === val);
      this.c_subjects = data.subjects ? data.subjects : [];
    },
    selected_subject(val) {
      if (val) {
        let cid = this.selected_class;
        this.$store.dispatch("marks/getAll", {
          class_id: cid,
          subject_id: val
        });
      }
    },
    marks(val) {
      this.c_marks = val;
      this.refresh_key + 1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/teacher/assessment/assessment.vue